import { AdminPanel } from './AdminPanel.tsx';

interface Props {
  onClose: () => void;
  /** "Show on map" closes this page and points the map there — see App.tsx's showOnMap. */
  onFlyTo: (lat: number, lon: number, zoom?: number) => void;
  onChanged: (pendingCount: number) => void;
}

/**
 * A full page, not a sidebar tab — reviewing view points and managing
 * accounts was cramped in the old 360px-wide Review tab (see App.tsx's
 * adminPageOpen branch, which renders this in place of the whole map +
 * sidebar layout, not alongside it). Opened from a button in Settings,
 * admin-only.
 */
export function AdminPage({ onClose, onFlyTo, onChanged }: Props) {
  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <picture className="brand">
          <source srcSet="/whaletail-horizontal-dark.png" media="(prefers-color-scheme: dark)" />
          <img src="/whaletail-horizontal.png" alt="WhaleTail" height={28} />
        </picture>
        <span className="admin-page-title">Admin</span>
        <span className="spacer" />
        <button type="button" className="btn" onClick={onClose}>
          ← Back to map
        </button>
      </header>
      <div className="admin-page-body">
        <AdminPanel onFlyTo={onFlyTo} onChanged={onChanged} />
      </div>
    </div>
  );
}
